// You can write more code here

/* START OF COMPILED CODE */

import Phaser from "phaser";
import BtnPauseAudio from "../btns/BtnPauseAudio";
import BtnPauseClose from "../btns/BtnPauseClose";
import FitTextToBounds from "../../components/core/FitTextToBounds";
import LocaliseText from "../../components/core/LocaliseText";
import BtnHomePause from "../btns/BtnHomePause";
/* START-USER-IMPORTS */
import GameUI from '../../scenes/GameUI';
import UIButton from '../../components/core/UIButton';
/* END-USER-IMPORTS */

export default class PauseMenu extends Phaser.GameObjects.Container {

  constructor(scene: Phaser.Scene, x?: number, y?: number) {
    super(scene, x ?? 960, y ?? 384);

    // cover
    const cover = scene.add.rectangle(0, 0, 1924, 772);
    cover.isFilled = true;
    cover.fillColor = 0;
    cover.fillAlpha = 0.6;
    this.add(cover);

    // menu
    const menu = scene.add.container(0, 0);
    this.add(menu);

    // arm
    const arm = scene.add.image(0, -296, "endscreen", "popup-arm.png");
    menu.add(arm);

    // menuBg
    const menuBg = scene.add.image(0, 0, "endscreen", "popup-pause-box.png");
    menu.add(menuBg);

    // btnPauseAudio
    const btnPauseAudio = new BtnPauseAudio(scene, -126, 9);
    menu.add(btnPauseAudio);

    // btnPauseClose
    const btnPauseClose = new BtnPauseClose(scene, 313, -129);
    menu.add(btnPauseClose);

    // Title
    const title = scene.add.container(1, -155);
    menu.add(title);

    // panelNine_1
    const panelNine_1 = scene.add.image(0, 0, "endscreen", "popup-heading-small.png");
    title.add(panelNine_1);

    // label
    const label = scene.add.text(0, 0, "", {});
    label.setOrigin(0.5, 0.5);
    label.text = "New text";
    label.setStyle({ "fontFamily": "Acme-Regular", "fontSize": "50px", "shadow.offsetY":3,"shadow.fill":true});
    label.setPadding({"left":10,"top":10,"right":10,"bottom":10});
    title.add(label);

    // btnHomePause
    const btnHomePause = new BtnHomePause(scene, 133, 11);
    menu.add(btnHomePause);

    // label (components)
    const labelFitTextToBounds = new FitTextToBounds(label);
    labelFitTextToBounds.maxWidth = 450;
    labelFitTextToBounds.constrainByWidth = true;
    const labelLocaliseText = new LocaliseText(label);
    labelLocaliseText.copyId = "paused";

    this.cover = cover;
    this.menu = menu;
    this.arm = arm;
    this.menuBg = menuBg;
    this.btnPauseAudio = btnPauseAudio;
    this.btnPauseClose = btnPauseClose;
    this.btnHomePause = btnHomePause;

    /* START-USER-CTR-CODE */
    this.menuBg.setInteractive();
    /* END-USER-CTR-CODE */
  }

  private cover: Phaser.GameObjects.Rectangle;
  private menu: Phaser.GameObjects.Container;
  private arm: Phaser.GameObjects.Image;
  private menuBg: Phaser.GameObjects.Image;
  private btnPauseAudio: BtnPauseAudio;
  private btnPauseClose: BtnPauseClose;
  private btnHomePause: BtnHomePause;
  public menuStartY: number = -600;
  public menuEndY: number = 0;

  /* START-USER-CODE */

  private closeCallback: (() => void) | undefined;

  public activate(closeCallback?: () => void) {
    this.closeCallback = closeCallback;

    this.transitionIn();
  }

  protected transitionIn() {
    this.btnPauseAudio.setButtonState(!this.getMusicAudioIsMuted());

    this.btnPauseClose.once(UIButton.events.clicked, this.transitionOut, this);
    // this.btnHome.once(UIButton.events.clicked, this.onHome, this);
    this.btnPauseAudio.on(UIButton.events.clicked, this.toggleMusicAudio, this);
    this.btnHomePause.on(UIButton.events.clicked, this.onHome, this);

    this.cover.alpha = 0;
    this.scene.add.tween({
      targets: this.cover,
      alpha: { from: 0, to: 1 },
      duration: 250,
      ease: Phaser.Math.Easing.Cubic.InOut
    });

    this.menu.y = this.menuStartY;
    this.scene.add.tween({
      targets: this.menu,
      y: { from: this.menuStartY, to: this.menuEndY },
      duration: 500,
      ease: Phaser.Math.Easing.Back.Out,
      delay: 250
    });

    this.scene.time.delayedCall(250, () => {
      this.cover.setInteractive();
      this.cover.once(Phaser.Input.Events.POINTER_UP, this.transitionOut, this);
    });
  }

  protected beforeExit() {
    this.cover.disableInteractive();
    this.cover.off(Phaser.Input.Events.POINTER_UP, this.transitionOut, this);

    this.btnPauseClose.off(UIButton.events.clicked, this.transitionOut, this);
    // this.btnHome.off(UIButton.events.clicked, this.transitionOut, this);
    this.btnPauseAudio.off(UIButton.events.clicked, this.toggleMusicAudio, this);
    this.btnHomePause.off(UIButton.events.clicked, this.onHome, this);

    this.scene.tweens.killTweensOf([this.menu, this.cover]);
  }

  protected transitionOut() {


    this.beforeExit();

    this.scene.add.tween({
      targets: this.menu,
      y: this.menuStartY,
      duration: 400,
      ease: Phaser.Math.Easing.Back.In
    });

    this.scene.add.tween({
      targets: this.cover,
      alpha: 0,
      duration: 250,
      delay: 400,
      ease: Phaser.Math.Easing.Cubic.InOut
    });

    this.scene.time.delayedCall(650, () => {
      this.closeCallback?.();
    });
  }

  public areYouSureClosed()
  {
    this.menu.y = this.menuStartY;
    this.scene.add.tween({
      targets: this.menu,
      y: { from: this.menuStartY, to: this.menuEndY },
      duration: 500,
      ease: Phaser.Math.Easing.Back.Out,
      delay: 250
    });
  }

  protected onHome() {
    // this.beforeExit();

    console.log("Go Home!");

    this.scene.add.tween({
      targets: this.menu,
      y: this.menuStartY,
      duration: 400,
      ease: Phaser.Math.Easing.Back.In,
      onComplete:()=>{
        this.scene.events.emit(GameUI.events.AreYouSure);
      }
    });

    // this.scene.app.AudioHandler.setChannelPause('sfx', false);
    // this.scene.app.AudioHandler.setChannelPause('music', false);


  }

  protected getSFXAudioIsMuted(): boolean {
    return this.scene.app.AudioHandler.getChannelMute('sfx');
  }

  protected getMusicAudioIsMuted(): boolean {
    return this.scene.app.AudioHandler.getChannelMute('music');
  }

  protected toggleSFXAudio() {
    let isMuted = this.getSFXAudioIsMuted();
    this.scene.app.AudioHandler.setChannelMute('sfx', !isMuted);
  }

  protected toggleMusicAudio() {
    let isMuted = this.getMusicAudioIsMuted();
    this.scene.app.AudioHandler.setChannelMute('music', !isMuted);

    isMuted = this.getSFXAudioIsMuted();
    this.scene.app.AudioHandler.setChannelMute('sfx', !isMuted);
  }


  /* END-USER-CODE */
}

/* END OF COMPILED CODE */

// You can write more code here
